import { render, staticRenderFns } from "./TemplateDesignHeader.vue?vue&type=template&id=0476029b"
import script from "./TemplateDesignHeader.vue?vue&type=script&lang=ts"
export * from "./TemplateDesignHeader.vue?vue&type=script&lang=ts"
import style0 from "./TemplateDesignHeader.vue?vue&type=style&index=0&id=0476029b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports